
import { defineComponent } from "vue";
import mpPopover from "../../../../components/mp-popover/mp-popover.vue";

export default defineComponent({
  components: { mpPopover },

  data() {
    return {
      showIntroductionVideo: false,
      // qiniuPlayer: <any>null,
    };
  },

  methods: {
    handleShowIntroductionVideo(visible: boolean) {
      if (visible) {
        this.showIntroductionVideo = true;
        this.$emit('showVideo', true);
        // this.$nextTick(() => {
        //   this.qiniuPlayer = new QPlayer({
        //     url: "https://alliance.yuesaolianmeng.com/alliancevue/gw0000a838c9b90b81e8bfc109f517a38b.mp4",
        //     container: document.getElementById("introductionPlayer"),
        //     autoplay: true,
        //     muted: false,
        //     isLive: false,
        //     loggerLevel: 3,
        //   });
        //   console.clear();
        // });
      } else {
        this.distoryPlayer();
      }
    },

    distoryPlayer() {
      // if (!this.qiniuPlayer) { console.clear(); return; };
      // console.log(this.qiniuPlayer);
      // this.qiniuPlayer.pause();
      // this.qiniuPlayer.destroy();
      this.$nextTick(() => {
        // this.qiniuPlayer = null;
        this.showIntroductionVideo = false;
        this.$emit('showVideo', false);
        // console.clear();
      });
    },
  }
});
